export default __webpack_public_path__ + "static/main_small-410cfc9d6551c2f8931dee6c9ff30fb7.jpg";